var _path, _path2, _path3, _path4, _g, _line, _line2, _line3, _line4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTrackAndField(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1024 1024",
    xmlSpace: "preserve",
    stroke: "currentColor",
    strokeWidth: 25,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M729,808.8H295c-128.7,0-233-104.3-233-233V448.2c0-128.7,104.3-233,233-233H729c128.7,0,233,104.3,233,233 v127.6C962,704.5,857.7,808.8,729,808.8z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M295,758.8c-100.9,0-183-82.1-183-183V448.2c0-100.9,82.1-183,183-183H729c100.9,0,183,82.1,183,183v127.6 c0,100.9-82.1,183-183,183H295z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M295,708.8c-73.4,0-133-59.7-133-133V448.2c0-73.4,59.7-133,133-133H729c73.4,0,133,59.7,133,133v127.6 c0,73.4-59.7,133-133,133H295z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M295,658.8c-45.8,0-83-37.3-83-83V448.2c0-45.8,37.3-83,83-83H729c45.8,0,83,37.3,83,83v127.6 c0,45.8-37.3,83-83,83H295z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 212.8,
    y1: 438.2,
    x2: 811.2,
    y2: 438.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 212.8,
    y1: 512,
    x2: 811.2,
    y2: 512
  }), /*#__PURE__*/React.createElement("line", {
    x1: 212.8,
    y1: 585.8,
    x2: 811.2,
    y2: 585.8
  }))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 682.2,
    y1: 365.2,
    x2: 682.2,
    y2: 215.2
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 447.6,
    y1: 658.8,
    x2: 447.6,
    y2: 708.5
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 380.3,
    y1: 709.9,
    x2: 380.3,
    y2: 759.6
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 303.7,
    y1: 758.8,
    x2: 303.7,
    y2: 808.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrackAndField);
export default __webpack_public_path__ + "static/media/TrackAndField.a1f1ade3bb37b070a97e157c1522d42f.svg";
export { ForwardRef as ReactComponent };